export default {
    BackendUrl: 'https://backend-production.talenyanetwork.com',
    WebAppUrl: 'https://us.webapp.talenyanetwork.com',
    inlinemanual: false,
    NODE_ENV: 'production',
};
